import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { MONITORING_BOOT_LOGS_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { MONITORING_BOOT_LOGS_REPORT } from "../interfaces/dashboard";

export default function MonitoringBootLogs() {
    const monitoringBootLogsReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.MONITORING_BOOT_LOGS_REPORT;

    const [monitoringBootLogsReportTableData, setMonitoringBootLogsReportTableData] = useState<MONITORING_BOOT_LOGS_REPORT[]>([]);

    useEffect(() => {
        setMonitoringBootLogsReportTableData(MONITORING_BOOT_LOGS_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType="MONITORING_BOOT_LOGS"
        tableColumns={monitoringBootLogsReportTableColumns}
        tableData={monitoringBootLogsReportTableData} />
    );
}